export default __webpack_public_path__ + "static/media/12.ead6d32d.svg";